export const successLight = '#D9EEDB';
export const errorLight = '#FDE3E4';

export const yellowMainLight = '#FFF9E8';
export const yellowMain = '#ffe57f';
export const yellowMainDark = '#F0B71C';

export const darkColor = '#434243';
export const greyOutlineColor = '#A5A5A5';
export const whiteColor = '#ffffff';
export const blackColor = '#000000';
export const bgMainContentColor = '#F5F5F5';
export const grey900 = '#212121';
export const redColor = '#FF0000';

export const darkLight = '#e3f2fd';
export const darkMain = '#2196f3';
export const darkDark = '#1e88e5';
export const dark800 = '#90caf9';
export const dark900 = '#1565c0';
export const darkTextSecondary = '#8492c4';

export const greyEDEDED = '#EDEDED';
export const grey50 = '#fafafa';
export const grey100 = '#f5f5f5';
export const grey200 = '#eeeeee';
export const grey700 = '#616161';
export const grey500 = '#9e9e9e';

export const orangeLight = '#fbe9e7';
export const orangeMain = '#ffab91';
export const orangeDark = '#d84315';
